import { atom } from 'jotai';
export const featureFlagsAtom = atom(null);
export const featureFlagsLoadingAtom = atom(false);
export const featureFlagsErrorAtom = atom(null);
export const featureFlagsCacheAtom = atom(null);
export const featureFlagsLastFetchAtom = atom(0);
export const isCacheValidAtom = atom((get) => {
    const cache = get(featureFlagsCacheAtom);
    if (!cache)
        return false;
    const now = Date.now();
    return now - cache.timestamp < cache.ttl;
});
export const validCacheDataAtom = atom((get) => {
    const isValid = get(isCacheValidAtom);
    const cache = get(featureFlagsCacheAtom);
    return isValid && cache ? cache.data : null;
});
